"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// (C) 2007-2020 GoodData Corporation
require("isomorphic-fetch");
var gooddata_1 = require("./gooddata");
exports.SDK = gooddata_1.SDK;
var xhr_1 = require("./xhr");
exports.ApiResponse = xhr_1.ApiResponse;
exports.ApiResponseError = xhr_1.ApiResponseError;
exports.ApiNetworkError = xhr_1.ApiNetworkError;
var execute_afm_1 = require("./execution/execute-afm");
exports.ApiExecutionResponseError = execute_afm_1.ApiExecutionResponseError;
var referenceHandling = __importStar(require("./referenceHandling"));
exports.referenceHandling = referenceHandling;
var DataLayer = __importStar(require("./DataLayer"));
exports.DataLayer = DataLayer;
var TypeGuards = __importStar(require("./typeGuards"));
exports.TypeGuards = TypeGuards;
var factoryBrowser = gooddata_1.factory(fetch.bind(window));
exports.factory = factoryBrowser;
exports.default = factoryBrowser();
